import React from 'react'

import { AdjustPaymentTarget } from '../AdjustPaymentModal'
import {
  TRANSACTION_COLUMNS,
  TRANSACTION_COPY,
  TRANSACTION_FILTER_OPTIONS,
  TRANSACTION_GRID_TEMPLATE,
  TransactionFilter,
} from './helpers'
import { transactionsOf } from './row-targets'
import QueuePanel from './QueuePanel'
import TransactionRow from './TransactionRow'
import { TRANSACTION_URL_CONTRACT } from './url-state'
import { useReviewQueuePanel } from './useReviewQueuePanel'
import { useRowDeepLink } from './useRowDeepLink'

/**
 * The "Unallocated payments" tab — the transactions the auto-allocator could not
 * place, each awaiting an Allocate (or a Post, for refunds).
 *
 * "Unallocated payments" is the operator-facing label only; the concept is an
 * unposted transaction and there is no `match` operation (CONTEXT.md). Hence
 * the component name, and hence `kind: 'transaction'` on the wire.
 *
 * The request param is `kind: 'transaction'`; the row discriminator on the
 * response is also `'transaction'` here, but do not generalise from that — the
 * discrepancy arm asks for `kind: 'discrepancy'` and matches `kind === 'issue'`.
 *
 * An inbound `?rqOpen=<transactionId>` opens one row's modal straight away —
 * see ./useRowDeepLink.
 */
const UnpostedTransactionsPanel: React.FC<{
  onOpenTarget: (target: AdjustPaymentTarget) => void
  canWrite: boolean
}> = ({ onOpenTarget, canWrite }) => {
  const panel = useReviewQueuePanel<TransactionFilter>(TRANSACTION_URL_CONTRACT)
  useRowDeepLink(panel, onOpenTarget)

  return (
    <QueuePanel
      panel={panel}
      copy={TRANSACTION_COPY}
      columns={TRANSACTION_COLUMNS}
      gridTemplateColumns={TRANSACTION_GRID_TEMPLATE}
      filterOptions={TRANSACTION_FILTER_OPTIONS}
      rows={transactionsOf(panel.items).map((row) => (
        <TransactionRow
          key={row.transactionId}
          row={row}
          canWrite={canWrite}
          onOpenTarget={onOpenTarget}
        />
      ))}
    />
  )
}

export default UnpostedTransactionsPanel
